import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { COLORS, UI_TEXT } from '../config/gameConfig';

const DraftNotification = ({ isVisible, draftText }) => {
  return (
    <AnimatePresence mode="wait">
      {isVisible && (
        <motion.div
          key={draftText}
          initial={{ opacity: 0, y: -20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -20, scale: 0.9 }}
          className="fixed top-16 left-0 right-0 mx-auto w-max max-w-[90vw] z-50 pointer-events-none"
        >
          <div
            className="px-4 py-2 border backdrop-blur-md font-mono rounded-lg shadow-lg"
            style={{
              backgroundColor: `${COLORS.notificationDraft}20`,
              borderColor: `${COLORS.notificationDraft}80`,
              boxShadow: `0 0 20px ${COLORS.notificationDraft}40`
            }}
          >
            <div
              className="text-xs font-bold text-center uppercase tracking-wider mb-1"
              style={{ color: COLORS.notificationDraft }}
            >
              {UI_TEXT.draftNotification.prefix}
            </div>
            <div className="text-sm text-white/90 font-serif italic text-center max-w-md">
              {draftText}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DraftNotification;